export default __webpack_public_path__ + "static/media/chairAlt.70062383.svg";